<template>
    <EmployeeDeniedServiceReports></EmployeeDeniedServiceReports>
</template>
<script>
    import EmployeeDeniedServiceReports from '@/components/EmployeeDeniedServiceReports.vue'
    export default {
        name: 'employee-service-reports',
        components: {
            EmployeeDeniedServiceReports
        }
    }
</script>